import { Row } from 'styled-bootstrap-grid';
import { styled, css } from 'styled-components';

import { Media } from '../../theme/Media.tsx';

export interface GroupSpacingProps {
  $disabledSpacer?: boolean;
}

const groupSpacingStyles = css<GroupSpacingProps>`
  @media ${Media.smMin} {
    gap: 24px 0;

    &:not(:last-child) {
      ${({ $disabledSpacer }) =>
        !$disabledSpacer &&
        css`
          margin-bottom: 24px;
        `}
    }
  }

  @media ${Media.xsMax} {
    gap: 8px 0;

    &:not(:last-child) {
      ${({ $disabledSpacer }) =>
        !$disabledSpacer &&
        css`
          margin-bottom: 8px;
        `}
    }
  }
`;

export const FormGroup = styled(Row)<GroupSpacingProps>`
  ${groupSpacingStyles}
`;

export const InnerGroup = styled.div<GroupSpacingProps>`
  ${groupSpacingStyles}
`;

export const LabelCompensationWrapper = styled.div`
  margin-top: 24px;
`;

const BaseFormLayout = styled.div`
  & + & {
    @media ${Media.mdMin} {
      margin-top: 24px;
    }

    @media ${Media.smMax} {
      margin-top: 8px;
    }
  }
`;

export const VerticalFormLayout = styled(BaseFormLayout)`
  display: flex;
  flex-direction: column;

  @media ${Media.mdMin} {
    gap: 24px;
  }

  @media ${Media.smMax} {
    gap: 8px;
  }
`;
